module.exports = __webpack_public_path__ + "img/th.0a325eb1.svg";